import React from 'react';

/**
 * Patriot-style wordmark: "dot" in white + "box.ai" in brand red.
 * Mirrors "PATRIOT analytics" treatment from patriotanalytics.ai.
 *
 * variant:
 *  - "dark": for dark navy headers/footers (default for our forced-dark UI)
 *  - "light": kept for backward compatibility (renders identical wordmark)
 */
const DotboxLogo = ({ className = "", showText = true, variant = "dark" }) => {
  // Determine "dot" color based on variant
  const dotColor = variant === "light" ? "text-[#0F1730]" : "text-white";

  // Parse height from className to determine text size
  let textSize = "text-xl";
  if (className.includes("h-12")) {
    textSize = "text-3xl";
  } else if (className.includes("h-10")) {
    textSize = "text-2xl";
  } else if (className.includes("h-8")) {
    textSize = "text-xl";
  }

  const layoutClasses = className
    .replace(/h-\d+/g, "")
    .replace(/w-auto/g, "")
    .trim();

  return (
    <div className={`flex items-center ${layoutClasses}`} data-testid="dotbox-logo">
      <span
        className={`${textSize} font-bold tracking-tight leading-none`}
        style={{ fontFamily: "'Inter', 'Segoe UI', 'Helvetica Neue', Arial, sans-serif" }}
      >
        <span className={dotColor}>dot</span>
        <span className="text-[#DC2626]">box.ai</span>
      </span>
    </div>
  );
};

export default DotboxLogo;
